export default __webpack_public_path__ + "static/Plots0007-4495832e3939133dd27b0f61726998f1.jpg";